import { ReactNode } from "react";
import { cn } from "@/zapi-frontend/shared/lib/utils";

type TUserMessageProps = {
  children: ReactNode;
  className?: string;
};

export function UserMessage({ children, className }: TUserMessageProps) {
  return (
    <div
      className={cn(
        "flex w-full items-center justify-end bg-transparent py-[12px]",
        className
      )}
    >
      <div
        className="flex max-w-[292px] flex-col items-end gap-[6px] rounded-2xl rounded-br-md bg-innoveraZinc-100 px-4 py-2.5"
      >
        <div className="flex w-full flex-col items-start gap-[6px] text-[14px] leading-[22px] text-innoveraZinc-900">
          {children}
        </div>
      </div>
    </div>
  );
}
